module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABXSURBVEiJY7T22yXFQEPAREvDRy0gCrBgE/zzl92HLMOYf24hygIGBgaG/4z/SEpdjP+ZnmETH/pxMGrBqAWjFgxUYcfAgLtsoYoF2EpFcsHQj4OhbwEAN8oNMe3PtHwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/month.png
// module id = awGC
// module chunks = 0